import React from 'react';
import { Button, Message, useToaster } from 'rsuite';
import { FormModal } from '../../common/FormModal';
import { useFormErrors } from '../../common/useFormErrors';
import * as blogCategoriesApi from '../../api/blogCategories';
import BlogCategoryModalContent from './BlogCategoryModalContent';

type Props = {
  open: boolean;
  onClose: () => void;
  onCreated: () => void;
};

export default function CreateBlogCategoryModal({
  open,
  onClose,
  onCreated,
}: Props) {
  const toaster = useToaster();
  const [slug, setSlug] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [titleEn, setTitleEn] = React.useState('');
  const [titleDe, setTitleDe] = React.useState('');

  const { errorSummary, setApiError, clearErrors } = useFormErrors({
    fallbackMessage: 'Не вдалося створити категорію. Спробуйте пізніше',
    resetOn: [open],
  });

  React.useEffect(() => {
    if (!open) {
      return;
    }
    setSlug('');
    setTitle('');
    setTitleEn('');
    setTitleDe('');
  }, [open]);

  const handleSubmit = async () => {
    clearErrors();
    if (!slug.trim() || !title.trim()) {
      toaster.push(
        <Message type="warning" showIcon closable>
          Заповніть slug та назву
        </Message>,
        { placement: 'topEnd', duration: 2000 }
      );
      return;
    }

    try {
      await blogCategoriesApi.create(slug, title, titleEn, titleDe);
      onClose();
      toaster.push(
        <Message type="success" showIcon closable>
          Категорію створено
        </Message>,
        { placement: 'topEnd', duration: 1500 }
      );
      onCreated();
    } catch (err: any) {
      const errorMessage = setApiError(err)[0];
      toaster.push(
        <Message type="error" showIcon closable>
          {errorMessage}
        </Message>,
        { placement: 'topEnd', duration: 2000 }
      );
    }
  };

  return (
    <FormModal
      open={open}
      onClose={onClose}
      title="Створити категорію"
      errorSummary={errorSummary}
      footer={
        <>
          <Button onClick={handleSubmit} appearance="primary">
            Створити
          </Button>
          <Button onClick={onClose} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      <BlogCategoryModalContent
        slug={slug}
        title={title}
        titleEn={titleEn}
        titleDe={titleDe}
        setSlug={setSlug}
        setTitle={setTitle}
        setTitleEn={setTitleEn}
        setTitleDe={setTitleDe}
      />
    </FormModal>
  );
}
